<template>
  <div class="dash-header">
    <div class="dash-header-inner">
      <div class="welcome flexItem">
        <template>
          <router-link to="/" class="dash-head-logo">
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/logo.png" />
          </router-link>
        </template>
        <div class="ResMenu" v-if="oWidth <= 750" :class="{'on':isShow}" @click="menuClick">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="searchDiv" v-if="!$config.settings.onlayReg">
          <el-input readonly size="mini" v-if="subjectType != 'ACTOR'" @click.native="goSearch"
            :placeholder="$t('homes.searchPlaceHolder')" prefix-icon="el-icon-search" v-model="searchInput"> </el-input>
        </div>
      </div>

      <div class="welcome">
        <span v-if="isLogin" class="account" @click="goDash">{{$t('finds.myWorker')}}</span>
        <span v-if="isLogin" class="line-mar">|</span>
        <template v-if="$store.state.config.hideElement">
          <template v-if="isLogin">
            <span>{{ name || loginAccount || '--' }}</span>
            <a href="javascript:void(0)" @click="LogOut">{{ $t('logout') }}</a>
            <span class="line-mar">|</span>
          </template>
          <span class="link Link" @click="goLogin" :class="{'login_link_en': language == 'en'}" v-else><span
              class='login-iconfont iconfont icon92act_zhucedenglu'></span>{{ $t('registerLogin') }}</span>
          <span class="head-roles" v-if="isLogin"><i>{{ $t('finds.currentUser') }}：</i>
            <font>{{ subjectType == 'VISITOR' ? $t('actor') : $t('exhibitors') }}</font>
          </span>
        </template>
        <div class='el-menu-iconfont language-change'>
          <i class="iconfont iconicon_A" @click="setLang('en')" v-if="language === 'zh'"></i>
          <i class="iconfont iconyuyanqiehuancon" @click="setLang('zh')" v-if="language === 'en'"></i>
        </div>
      </div>
    </div>
    <div class="navBar" :style="{display: (isShow == false ? 'none' : 'block')}"
      :class="{'limit-nav': $config.settings.onlayReg}" @click="noVisitorTodoAction">
      <nav>
        <el-menu :default-active="activeIndex" class="el-menu-header" mode="horizontal" :router="true">
          <el-menu-item index="/" @click="navRouter('', '001035001')">{{ $t('homes.Home') }}</el-menu-item>
          <el-menu-item index="/find/actor" @click="navRouter('actor','001035002')"
            v-if="subjectType == 'VISITOR'||subjectType == ''">{{ $t('homes.Exhibitor') }}</el-menu-item>
          <el-menu-item index="/find/product" @click="navRouter('product','001035003')"
            v-if="subjectType == 'VISITOR'||subjectType == ''">{{ $t('homes.Products') }}</el-menu-item>
          <template v-if="$store.state.config.hideElement">
            <el-menu-item index="/find/person" @click="navRouter('person')" v-if="subjectType == 'ACTOR'">{{
              $t('homes.Visitor') }}</el-menu-item>
            <el-menu-item index="/find-opportunity" @click="navRouter('find-opportunity', '001035005')">{{
              $t('finds.businessCircle') }}</el-menu-item>
            <!-- @click="navRouter('VR', null, 'https://www.3dqiye.com//anli/klyf/xbh/21a/')" -->
            <li class="el-menu-item" v-if="false">
              <a href="javascript:;" class="external_link">{{ $t('VR Exhibition') }}</a>
            </li>
            <li class="el-menu-item" v-if="(subjectType == 'VISITOR'||subjectType == '') && false"
              @click="navRouter('sand-table', null, 'http://izt.eastfair.cn/shapan_jjxz/index.html')">
              <a href="javascript:;" class="external_link">{{ $t('homes.floorplanGuide') }}</a>
            </li>
            <!-- <el-menu-item index="/live" @click="navRouter('live', '001035006')">{{ subjectType == 'ACTOR' ? $t('homes.concurrentEvents') : $t('homes.Live')}}</el-menu-item> -->
            <!-- <el-menu-item index="/qa">{{ $t('homes.QA') }}</el-menu-item> -->
            <template v-if="$store.state.config.hideDockingMeetingOrIntentionalOrder">
              <el-menu-item v-if="subjectType == 'VISITOR'||subjectType == ''" index="/purchaseMeeting">{{
                $t('homes.purchaseMeeting') }}</el-menu-item>

              <el-menu-item v-if="subjectType == 'ACTOR'" index="/meetingList">{{ $t('meetingList') }}</el-menu-item>


              <li class="el-menu-item" v-if="$config.exhibitorManual && $config.exhibitorManual_en">
                <a :href="$config.exhibitorManual" target="_blank" class="external_link"
                  v-if="language === 'zh'">{{$t('exhibitorManual')}}</a>
                <a :href="$config.exhibitorManual_en" target="_blank" class="external_link" v-if="language === 'en'">{{
                  $t('exhibitorManual') }}</a>
              </li>

              <li class="el-menu-item" v-if="$config.aboutUs.zh && $config.aboutUs.en">
                <a :href="$config.aboutUs.zh" target="_blank" class="external_link"
                  v-if="language === 'zh'">{{$t('homes.About')}}</a>
                <a :href="$config.aboutUs.en" target="_blank" class="external_link" v-if="language === 'en'">{{
                  $t('homes.About') }}</a>
              </li>
              <!-- <el-menu-item @click="navRouter('onLineMeeting')">{{ $t('在线会议') }}</el-menu-item> -->
              <el-menu-item index="/aboutus" @click="navRouter('aboutus')">{{ $t('homes.About') }}</el-menu-item>
            </template>
          </template>

          <!-- <el-menu-item index="/onLineMeeting" @click="navRouter('onLineMeeting')">{{ $t('在线会议') }}</el-menu-item> -->
        </el-menu>
      </nav>
    </div>

  </div>
</template>
<script>
import { watchLog } from '@/api/live'
import { mapState, mapGetters } from 'vuex'
import { getUserInfoFn } from '@/permission'

export default {
  name: 'DashHeader3',
  components: {
  },
  data() {
    return {
      isShow: false,
      oWidth: document.body.clientWidth,
      activeIndex: '/',
      searchInput: ''
    }
  },
  computed: {
    ...mapState({
        newMessageComing: state => state.timStore.newMessageComing,
    }),
    ...mapGetters(['language', 'name', 'isLogin', 'info', 'subjectType', 'loginAccount']),
    noAdmin() {
      return (
        !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
      )
    }
  },
  watch: {
    $route: function() {
      this.menuActive()
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.menuActive()
    });
    if(this.oWidth > 750){
      this.isShow = true
    }else{
      this.isShow = false
    }

    if (this.isLogin) {
      getUserInfoFn()

      console.log('indexHeader头部组件 getUserInfoByToken')
    }
  },
  methods: {
    navRouter(name, num, url) {
        if (num) {
            this.statistics(num)
        }
        window.PC.$RangersEventNav(name)
        if (url) {
            this.openNewPage(url, true)
        }
        this.menuClick()
    },
    statistics(action) {
      this.commonStatistics(action)
    },
    menuActive: function() {
      let path = this.$route.path
      if (this.$route.meta && this.$route.meta.pPath) {
        path = this.$route.meta.pPath
      }
      this.activeIndex = path  
    },
    setLang(language) {
      this.$i18n.locale = language
      this.$store.commit('SET_LANGUAGE', language)
      location.reload()
    },
    LogOut() {
      if (this.$route.name == 'liveDetail' && this.$route.params.id != '') {
        let watchType = sessionStorage.getItem('watchType') || 1
        try {
          watchLog({ liveId: this.$route.params.id, state: 2, watchType: Number(watchType) }).then((res)=>{
            console.log(res)
            this.$store.dispatch('LogOut').then(() => {
              this.$router.push('/')
            })
          })
        } catch (error) {
          console.log(error)
        }
        
      }else {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push('/')
        })
      }
    },
    customerService(item) {
      item.position = this.$t('Online Service')
      this.$store.commit('setReceiver', item)
      this.$store.commit('toogleChatDialog')
    },
    goSearch() {
      this.navRouter("search")
      this.$router.push('/search-list')
    },
    goDash() {
      this.navRouter("workbench")
      if (this.subjectType === 'VISITOR' && this.$config.settings.onlayReg2) {
        this.$router.push('/profile')
        return
      }
      this.$router.push('/opportunity-manage/publish')
    },
    goLogin() {
      this.navRouter("signUp")
      // this.$store.commit('SET_SUBJECTTYPE', '')
      // this.loginSource()
      // TODO 登录观众
      this.$store.commit('SET_SUBJECTTYPE', 'VISITOR')
      this.loginSource('/login/person')
    },
    // 导航是否显示
    menuClick(){
      if(this.oWidth <= 750){
        this.isShow = !this.isShow
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
link-color = $color-main
link-hover = $color-main-hover

.limit-nav {
  position: relative;

  &:before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index 100
  }
}

.account {
  color: $color-main;
  cursor pointer;

  &:hover {
    opacity: .8;
    text-decoration underline;
  }
}
.line-mar {
  color: $color-gray-d9 
}
.external_link
  display block
.searchDiv
    display: inline-block;
    margin-left: 150px;
    width 400px;
    transition: all .3s;
    .el-select .el-input {
        width: 100px;
    }
    .input-with-select .el-input-group__prepend {
        background-color: $color-white;
    }
a
  color link-color
  &:hover
    color link-hover
.homeHeader
  .exhibitors{
    background  $color-exhibitors
  }
  .visitor{
    background  $color-index-homeHeader-vistor
    border 1px solid $color-index-homeHeader-vistor
  }
  .navBar
    width 100%
    background $color-index
    text-align: center;
    height 50px
  .iconfont
    display: block
    position relative
    top 0
    left 0
    padding-top 2px
    width 25px
    font-size 25px
    cursor pointer
    margin: 0
  nav
    display: inline-block;
    vertical-align: middle;
    .el-menu-item
      min-width 130px
      text-align center
      height 50px;
      line-height 50px
      color: $color-white !important
      background-color : $color-main !important
      transition: all .3s;
      &:hover
      &.is-active
        background-color $color-index-navBar-hover !important
      &.el-menu-iconfont:hover
        background-color transparent!important
    ul
      box-sizing border-box
    a
      color $color-white
    a:hover
      color $color-white
    > a
      display inline-block
      padding 0 12.5px
      text-align center
      position relative
      &:before
        content ''
        position absolute
        right 0
        top 5px
        width 1px
        height 12px
        background $color-black-15
      &:last-child:before
        display none

.dash-header-inner
  max-width $container-width
  margin 0 auto
  padding 0 15px
  height 68px
  display flex
  align-items center
  justify-content space-between
  color $color-black-65
  font-weight 400
  line-height 20px
  .welcome
    font-size 12px

    .dash-head-logo
      display inline-block
      height 59px
      width 219px
      img
        height 100%
    .head-roles
      margin-right: 0;
      i 
        font-style initial
      font
        color $color-index
    *
      margin-right 12px
.el-menu-header{
    height 50px
}
.dash-header .navBar .el-menu.el-menu--horizontal .el-menu-item{
    min-width 130px
    text-align center
    height 50px;
    line-height 50px

    &.el-menu-iconfont{
        min-width: 50px;
    }
}
.Menu{
  display none
}

@media (max-width: 1240px) {
    .searchDiv {
        margin-left: 120px;
        width: 250px;
    }

    .dash-header .navBar .el-menu.el-menu--horizontal .el-menu-item {
        min-width: 128px;
    }
}
</style>
